import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { MessagesError, MessagesNoResults } from "components/Messages";
import DailyReportCard from "./DailyReportCard";

/**
 * DailyReportLayout
 * Displays daily standup reports grouped by date in a card-based layout
 *
 * @param {Object}     data - Contains reportsByDate object
 * @param {Boolean}    loading - Loading state
 * @param {Object}     error - Error object if any
 */
const DailyReportLayout = ({ data, loading, error }) => {
  if (loading) return <Loading />;

  if (error) {
    return <MessagesError messageId="Squads.Squad.DailyReport.Error" />;
  }

  const { participantReports, participationMetrics } = data || {};

  if (!Object.keys(participantReports || {}).length) {
    return (
      <MessagesNoResults
        title="Squads.Squad.DailyReport.EmptyTitle"
        description="Squads.Squad.DailyReport.EmptyDescription"
      />
    );
  }

  return (
    <ReportsContainer>
      {Object.keys(participantReports).map((date) => (
        <DailyReportCard
          key={date}
          date={date}
          reports={participantReports[date]}
          participationMetrics={participationMetrics[date]}
        />
      ))}
    </ReportsContainer>
  );
};

const Loading = () => (
  <ReportsContainer>
    <DailyReportCard loading />
    <DailyReportCard loading />
    <DailyReportCard loading />
  </ReportsContainer>
);

const ReportsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

DailyReportLayout.propTypes = {
  data: PropTypes.shape({
    reportsByDate: PropTypes.object,
  }),
  loading: PropTypes.bool,
  error: PropTypes.object,
};

export default DailyReportLayout;
